import Base from "../base/Base";


//该类表示自定义的主题
export default function Theme(id = null, component = null, name = null, description = null, logoRemark = null, editComponent = null) {

	//extend Base's Attributes.
	Base.call(this, arguments);

	this.id = id;
	this.name = name;
	this.description = description;
	this.logoRemark = logoRemark;

	//如果可编辑的话，必须指定一个editComponent
	this.editComponent = editComponent;

	//view是一个vue component类型。
	this.component = component;

	//预览的数据 这是一个topic的json对象。
	this.topicJson = null;
}


//extend Base's methods.
Theme.prototype = new Base();
Theme.prototype.constructor = Theme;

//We use this method to get the full js Object.
Theme.prototype.render = function (obj) {

	Base.prototype.render.call(this, obj);

}

//获取预览链接
Theme.prototype.getPreviewLocation = function () {
	return "preview-theme-" + this.id;
}


// WEBPACK FOOTER //
// ./src/common/model/lover/Theme.js